module.exports = __webpack_public_path__ + "media/images/icons/v2/x-close-a177993230456053ddcdd05a2cd78054.svg";